import useSWR from "swr";
import { PortalTopFanclubProps } from "./PortalTopFanclub";
import { useCallback } from "react";

export const useGetPortalTopFanclub = () => {
  const shuffleArray = useCallback(
    (array: PortalTopFanclubProps["brandList"]) => {
      const randomArray = array.slice().flatMap((_) => {
        const randomIndex = Math.floor(Math.random() * array.length);
        const item = array[randomIndex];
        array.splice(randomIndex, 1);

        if (!item) return [];

        return item;
      });

      return randomArray;
    },
    []
  );

  const { data: fanclub, error } = useSWR("useGetPortalTopFanclub", () => {
    return shuffleArray([
      {
        thumbnail:
          "https://public-web.devspwn.net/crew/juntaterashima/brandIcon.png",
        brandName: "寺島惇太 アーティストメンバーシップ",
        brandSlug: "juntaterashima",
      },
      {
        thumbnail:
          "https://public-web.spwn.jp/brandIcons/te_fd7pLzQiCQDWMyfWaQoF_br_d21Zk76ODNUvBGS47tKo_1705601500869_b04602b5-1ace-47a5-9dbe-61c7ca80096f_500x500",
        brandName: "未確認動物うまぴ / VTuber",
        brandSlug: "umapi",
      },
      {
        thumbnail:
          "https://public-web.spwn.jp/brandIcons/te_GKNRJudMOWtQn0cbVVxO_br_pmQ7CiK8M9T5bMLQTWVa_1703703916388_500fa294-9466-4d31-ab83-343901f0059c_500x500",
        brandName: "七篠さよ",
        brandSlug: "7shi0sayo",
      },
      {
        thumbnail:
          "https://public-web.spwn.jp/brandIcons/gf2qdwksadscyi5p6l59rib4_bdqhudihubjtj8i0w6nkxv5w_1727340396002_d37c9561-4de7-41e4-b5ad-e8e2a3b4fa66_500x500",
        brandName: "GAKUTO-JAM",
        brandSlug: "gakuto-jam",
      },
      {
        thumbnail:
          "https://public-web.spwn.jp/brandIcons/xxt2694aakd3gppxz5d2yn6z_fztnmcrdoihnqge0osclxrrg_1736214248327_3cdb128c-2d8e-4463-a876-e137e1c2062e_500x500",
        brandName: "梅津瑞樹",
        brandSlug: "umetsu-m",
      },
      {
        thumbnail:
          "https://public-web.spwn.jp/brandIcons/s58gdn6ti5mx3wqwek3g5wfl_gb6qc2v3lgt0unnzpz9be4c0_1744782215150_75adbe92-700b-40dc-b2b7-1c7696ea1fb3_500x500",
        brandName: "赤澤燈・陳内将の笑ってじんとも！！",
        brandSlug: "jintomo-spwn",
      },
      {
        thumbnail:
          "https://public-web.spwn.jp/brandIcons/leqnp5v71i9atj8pkx0wma63_jjvoniuh33jtesojhh6qac6v_1751274504395_a1c90206-c9ba-4314-bf1b-d88c5f3f7101_500x500",
        brandName: "紫月杏朱彩のお姫様になるんだもん☆",
        brandSlug: "azupri",
      },
    ]);
  });

  return {
    fanclub,
    error,
  };
};
